import React, { useCallback, useMemo, useState } from 'react';

type MediaQueueStatus = null | 'failed';
interface MediaQueueState {
  status: MediaQueueStatus;
  message: null | string;
}

// TODO: figure out way to get data from tabs when not visible
// TOOD: convert to a stack/map where multiple sources can provide errors at the same time
export const mediaQueueContext = React.createContext({
  status: null,
  message: null,
  handleStatusChange: (state: MediaQueueState) => undefined
});

export const MediaQueueContextProvider = React.memo<React.PropsWithChildren>(({ children }) => {
  const [status, setStatus] = useState(null);
  const [message, setMessage] = useState(null);

  const handleStatusChange = useCallback(
    (state: MediaQueueState) => {
      if (state.status !== undefined) {
        setStatus(state.status);
      }
      if (state.message !== undefined) {
        setMessage(state.message);
      }
    },
    [setStatus, setMessage]
  );

  const value = useMemo(() => {
    return {
      status,
      message,
      handleStatusChange
    };
  }, [status, message, handleStatusChange]);

  return (
    <mediaQueueContext.Provider value={value}>
      {children}
    </mediaQueueContext.Provider>
  );
});
